/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, MenuItem, Typography } from "@mui/material";
import {
  FormDatePicker,
  FormTextField,
  GridCardContent,
} from "components/atoms";
import { FormContainer, FormContent } from "components/molecules";
import { FormikHelpers, useFormik } from "formik";
import { ICreateZoneRequest, IUpdateZoneRequest } from "model/Zone/IZone";
import { EStatus } from "model/Type/EActivationStatus";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { MasterDataActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { I18nTranslator, translations } from "utils/i18n";
import * as yup from "yup";

const validateSchema = yup.object().shape({
  zoneName: yup.string().required(translations.yupError.required),
  zoneCode: yup
    .string()
    .max(3, "Nhiều nhất 3 kí tự")
    .required(translations.yupError.required),
});

enum EPalletType {
  WOOD = "PW",
  FLAT_PLASTIC = "PP",
  HOLE_PLASTIC = "PH",
  ALUMINUM = "PA",
}

const PalletDetail = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const isAdd = location.pathname.includes("new");
  const action = useAppSelector(
    (state) => state.MasterDataReducer.pallet.action
  );

  const initialValues = isAdd
    ? {
        type: EPalletType.WOOD,
        usedDate: null,
      }
    : {};

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: validateSchema,
    onSubmit: (values: any, { validateForm }: FormikHelpers<any>) => {
      validateForm().then(() => {
        const createRequest: ICreateZoneRequest = {
          ...values,
          zoneCode: values.zoneCode.toUpperCase(),
          status: values.status === EStatus.ACTIVE,
        };
        if (isAdd) {
          dispatch(MasterDataActions.createZone.request(createRequest));
        } else {
          const updateRequest: IUpdateZoneRequest = {
            ...values,
            zoneCode: values.zoneCode.toUpperCase(),
            status: values.status === EStatus.ACTIVE,
          };
          dispatch(MasterDataActions.updateZone.request(updateRequest));
        }
      });
    },
  });

  const getCardTitle = () => {
    return isAdd
      ? translations.masterData.addZone
      : translations.masterData.editZone;
  };
  const handleDeleteItem = () => {
    // DialogHelper.openConfirmDeleteDialog({
    //   //   itemName: initialValues?.zoneName,
    //   //   onDelete: () => _deleteZone(initialValues?.id!),
    // });
  };

  const _deleteZone = (id: string) => {
    dispatch(
      MasterDataActions.deleteZone.request({
        id: id,
      })
    );
  };

  useEffect(() => {
    if (
      action === MasterDataActions.createZone.successName ||
      action === MasterDataActions.updateZone.successName
    ) {
      history.go(-1);
    }
  }, [action]);

  return (
    <GridCardContent>
      <GridCardContent sx={{ p: 2, width: "100%" }}>
        <FormContainer
          formik={formik}
          loading={action.includes("_REQUEST")}
          isAdd={isAdd}
          onDelete={handleDeleteItem}
        >
          <Typography variant="h3">{I18nTranslator(getCardTitle())}</Typography>
          <Form />
        </FormContainer>
      </GridCardContent>
    </GridCardContent>
  );
};

const Form = () => {
  return (
    <Grid container rowSpacing={2}>
      <FormGeneralInformation />
    </Grid>
  );
};

const FormGeneralInformation = () => {
  return (
    <FormContent
      title={I18nTranslator(translations.masterData.generaInformation)}
    >
      <Grid xs={12} item>
        <FormTextField
          label={I18nTranslator(translations.masterData.palletType)}
          select
          id="type"
        >
          <MenuItem value={EPalletType.WOOD}>
            {I18nTranslator(translations.type.wood)}
          </MenuItem>
          <MenuItem value={EPalletType.FLAT_PLASTIC}>
            {I18nTranslator(translations.type.flatPlastic)}
          </MenuItem>
          <MenuItem value={EPalletType.HOLE_PLASTIC}>
            {I18nTranslator(translations.type.holePlastic)}
          </MenuItem>
          <MenuItem value={EPalletType.ALUMINUM}>
            {I18nTranslator(translations.type.aluminum)}
          </MenuItem>
        </FormTextField>
      </Grid>
      <Grid xs={12} item>
        <FormDatePicker
          id="usedDate"
          label={I18nTranslator(translations.masterData.palletType)}
        />
      </Grid>
      <Grid xs={12} item>
        <FormTextField
          label={I18nTranslator(translations.masterData.zoneDescription)}
          fullWidth
          placeholder={I18nTranslator(translations.placeholder.zoneDescription)}
          id="description"
          multiline
          rows={4}
        />
      </Grid>
      <Grid xs={6} item>
        <FormTextField
          label={I18nTranslator(translations.masterData.status)}
          select
          id="status"
        >
          <MenuItem value={EStatus.ACTIVE}>
            {I18nTranslator(translations.masterData.active)}
          </MenuItem>
          <MenuItem value={EStatus.IN_ACTIVE}>
            {I18nTranslator(translations.masterData.inactive)}
          </MenuItem>
        </FormTextField>
      </Grid>
    </FormContent>
  );
};

export default PalletDetail;
